/* REB-225 — editorial article page behaviour:
   - builds the "On this page" TOC (desktop rail + mobile dropdown) from the article's H2s
   - scrollspy highlight + reading progress %
   - wraps tables in a scroll container for mobile overflow
   Articles are auto-drafted by the content engine, so the TOC must always self-generate. */

(function () {
  'use strict';

  function init() {
    preservePreviewParams();
    initBlogSearch();

    var content = document.getElementById('ed-article-content');
    if (!content) return;

    wrapTables(content);
    buildToc(content);
    bindShare();
  }

  /* While previewing via ?view=editorial (template not yet assigned to the blog),
     blog-internal links would fall back to the default template. Carry the view
     param across so clicking around the preview stays in the editorial design.
     No-op on clean URLs, so harmless after rollout. */
  function preservePreviewParams() {
    var params = new URLSearchParams(window.location.search);
    if (!params.has('view')) return;

    var view = params.get('view');
    document.querySelectorAll('a[href^="/blogs/"]').forEach(function (link) {
      var url = new URL(link.href, window.location.origin);
      if (!url.searchParams.has('view')) {
        url.searchParams.set('view', view);
        link.href = url.pathname + url.search + url.hash;
      }
    });
  }

  /* Blog listing search: queries Shopify predictive search for articles,
     filters to this blog and swaps the results in for the hero + grid. */
  function initBlogSearch() {
    var input = document.querySelector('[data-ed-search]');
    if (!input) return;

    var main = document.querySelector('[data-ed-blog-main]');
    var results = document.querySelector('[data-ed-search-results]');
    var empty = document.querySelector('[data-ed-search-empty]');
    var blogUrl = input.getAttribute('data-blog-url');
    var timer;
    var controller;

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(run, 250);
    });

    function reset() {
      if (main) main.hidden = false;
      results.hidden = true;
      empty.hidden = true;
      results.innerHTML = '';
    }

    function run() {
      var q = input.value.trim();
      if (!q) {
        reset();
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();

      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=article&resources[limit]=10&resources[options][fields]=title,body';

      fetch(url, { signal: controller.signal })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          var articles = (data.resources.results.articles || []).filter(function (a) {
            return a.url.indexOf(blogUrl) === 0;
          });

          results.innerHTML = articles.map(renderCard).join('');
          preservePreviewParams();
          if (main) main.hidden = true;
          results.hidden = articles.length === 0;
          empty.hidden = articles.length > 0;
        })
        .catch(function (error) {
          if (error.name !== 'AbortError') reset();
        });
    }

    function renderCard(a) {
      var image = a.featured_image && a.featured_image.url
        ? '<a class="ed-card__media" href="' + a.url + '" tabindex="-1" aria-hidden="true">' +
            '<img src="' + a.featured_image.url + '" alt="' + escapeHtml(a.featured_image.alt || a.title) + '" loading="lazy"></a>'
        : '';
      return '<article class="ed-card">' + image +
        '<h3 class="ed-card__title"><a href="' + a.url + '">' + escapeHtml(a.title) + '</a></h3>' +
        '</article>';
    }
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function wrapTables(content) {
    content.querySelectorAll('table').forEach(function (table) {
      if (table.parentElement.classList.contains('ed-table-scroll')) return;
      var wrap = document.createElement('div');
      wrap.className = 'ed-table-scroll';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  function buildToc(content) {
    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
    var railToc = document.querySelector('[data-ed-toc]');
    var lists = document.querySelectorAll('[data-ed-toc-list]');
    var mobileToc = document.querySelector('[data-ed-toc-mobile]');

    if (!headings.length || !lists.length) {
      if (railToc) railToc.hidden = true;
      if (mobileToc) mobileToc.hidden = true;
      return;
    }

    headings.forEach(function (h, i) {
      if (!h.id) h.id = 'section-' + (i + 1);
    });

    lists.forEach(function (list) {
      headings.forEach(function (h, i) {
        var li = document.createElement('li');
        li.className = 'ed-toc__item';

        var a = document.createElement('a');
        a.className = 'ed-toc__link';
        a.href = '#' + h.id;

        var num = document.createElement('span');
        num.className = 'ed-toc__num';
        num.textContent = (i < 9 ? '0' : '') + (i + 1);

        var label = document.createElement('span');
        label.textContent = h.textContent.trim();

        a.appendChild(num);
        a.appendChild(label);
        li.appendChild(a);
        list.appendChild(li);

        a.addEventListener('click', function (event) {
          event.preventDefault();
          h.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', '#' + h.id);
          if (mobileToc) mobileToc.open = false;
        });
      });
    });

    initScrollSpy(content, headings);
  }

  function initScrollSpy(content, headings) {
    var links = document.querySelectorAll('.ed-toc__link');
    var progressEls = document.querySelectorAll('[data-ed-progress]');
    var ticking = false;

    function update() {
      ticking = false;

      var offset = 130;
      var current = -1;
      headings.forEach(function (h, i) {
        if (h.getBoundingClientRect().top <= offset) current = i;
      });

      links.forEach(function (link) {
        var index = Array.prototype.indexOf.call(link.closest('[data-ed-toc-list]').children, link.parentElement);
        link.classList.toggle('is-active', index === current);
      });

      if (progressEls.length) {
        var rect = content.getBoundingClientRect();
        var viewport = window.innerHeight;
        var total = rect.height - viewport;
        var read = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 1;
        var pct = Math.round(read * 100) + '%';
        progressEls.forEach(function (el) {
          el.textContent = pct;
        });
      }
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });

    update();
  }

  function bindShare() {
    document.querySelectorAll('[data-ed-copy-link]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        navigator.clipboard.writeText(window.location.href).then(function () {
          btn.classList.add('is-copied');
          var label = btn.getAttribute('aria-label');
          btn.setAttribute('aria-label', 'Link copied');
          setTimeout(function () {
            btn.classList.remove('is-copied');
            btn.setAttribute('aria-label', label);
          }, 2000);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
